import {
  createValidation,
  validatorRequired,
  validatorMaxLength,
} from '../../utils/formValidators';

import { formRegisterAdditionalFields } from '../../constants/formRegister';

export default createValidation([
  {
    name: formRegisterAdditionalFields.EMTAK_CODE,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorMaxLength(10)(field),
    ],
  },
  {
    name: formRegisterAdditionalFields.WORKERS_NUMBER,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterAdditionalFields.EHAK_CODE,
    validators: (field, form, props) =>
      props?.isEditMode || props?.isAdmin
        ? validatorRequired()(field)
        : undefined,
  },
]);
